import { render, staticRenderFns } from "./pageAccessComponent.vue?vue&type=template&id=4284a6c7&"
import script from "./pageAccessComponent.vue?vue&type=script&lang=js&"
export * from "./pageAccessComponent.vue?vue&type=script&lang=js&"
import style0 from "./pageAccessComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports